import { useEffect } from 'react';
import type { StudyPageTab, StudyTabContext } from './StudyPage';

/**
 * Asks a shell's tab whether it should be shown, through the tab's own hook,
 * and tells the page. One of these is rendered per tab that has a `useVisible`
 * (the list a shell passes is fixed per page), so the hook runs inside a
 * component of its own: the page cannot call it in a loop over the tabs, and
 * a tab's rule may need queries of its own (the AI tab asks which actions the
 * image's workspace turned on). Renders nothing.
 */
export function TabVisibility({ tab, ctx, onChange }: {
  tab: StudyPageTab & { useVisible: NonNullable<StudyPageTab['useVisible']> };
  ctx: StudyTabContext;
  onChange: (id: string, visible: boolean) => void;
}) {
  const visible = tab.useVisible(ctx);
  useEffect(() => {
    // No answer yet (a list still loading): the page keeps the last one.
    if (visible !== undefined) onChange(tab.id, visible);
  }, [tab.id, visible, onChange]);
  return null;
}
